/**
 * Which dashboard page the user is on right now, as a route pattern from the
 * page catalogue (e.g. `/omnibus/groups/:id`), not the concrete URL.
 *
 * Kept in a dependency-free module so `helpers/apiRequester` can stamp it on
 * every request (`X-Dashboard-Page`) without importing the router. Written by
 * `activity/PageViewTracker` on each route change.
 */
import { matchPath } from 'react-router-dom'
import { PAGE_PATHS } from '../access/pageCatalogue'

let currentPage: string | null = null

export const getCurrentPage = () => currentPage
export const setCurrentPage = (page: string | null) => {
    currentPage = page
}

const paramCount = (pattern: string) => (pattern.match(/:/g) || []).length

/**
 * Map a pathname to its catalogue route pattern. Prefers the most specific
 * match (fewest params); falls back to the pathname itself for routes that
 * are not in the catalogue (login, auth callback, profile).
 */
export const resolvePagePattern = (pathname: string): string => {
    let best: string | null = null
    for (const pattern of PAGE_PATHS) {
        if (!matchPath({ path: pattern, end: true }, pathname)) continue
        if (best === null || paramCount(pattern) < paramCount(best)) best = pattern
    }
    return best || pathname
}
